<template>
  <div class="ready-data business-open-content">
    <div style="height: 15px"></div>
    <div class="ready-data-content">
      <div style="clear: both">
        <div class="phy" style="margin-right: 25px; margin-left: 65px">
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">厂家直营店</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor1" :key="index" v-html="item">
              {{ item }}
            </p>
            <p>
              7、法人店铺授权委托书&nbsp;<span
                style="font-size: 13px; color: #9b9b9b"
                >请下载</span
              ><a
                target="_blank"
                :href="downFileUrl1"
                download="授权委托书模板.doc"
                style="color: #0089ef; font-size: 13px"
                >授权委托书模板</a
              >
            </p>
          </div>
        </div>
        <div class="phy" style="margin-left: 25px">
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">品牌专卖店</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor2" :key="index">{{ item }}</p>
            <p>
              8、法人店铺授权委托书&nbsp;<span
                style="font-size: 13px; color: #9b9b9b"
                >请下载</span
              ><a
                target="_blank"
                :href="downFileUrl1"
                download="授权委托书模板.doc"
                style="color: #0089ef; font-size: 13px"
                >授权委托书模板</a
              >
            </p>
          </div>
        </div>
      </div>
      <div style="clear: both">
        <div
          class="phy"
          style="margin-right: 25px; margin-left: 65px; margin-bottom: 40px"
        >
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">品类经营店</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor3" :key="index" v-html="item">
              {{ item }}
            </p>
            <p>
              8、法人店铺授权委托书&nbsp;<span
                style="font-size: 13px; color: #9b9b9b"
                >请下载</span
              ><a
                target="_blank"
                :href="downFileUrl1"
                download="授权委托书模板.doc"
                style="color: #0089ef; font-size: 13px"
                >授权委托书模板</a
              >
            </p>
          </div>
        </div>
        <div class="phy" style="margin-left: 25px">
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">综合经营店</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor3" :key="index" v-html="item">
              {{ item }}
            </p>
            <p>
              8、法人店铺授权委托书&nbsp;<span
                style="font-size: 13px; color: #9b9b9b"
                >请下载</span
              ><a
                target="_blank"
                :href="downFileUrl1"
                download="授权委托书模板.doc"
                style="color: #0089ef; font-size: 13px"
                >授权委托书模板</a
              >
            </p>
          </div>
        </div>
      </div>
      <div style="clear: both">
        <div
          class="phy1"
          style="margin-right: 25px; margin-left: 65px; margin-bottom: 40px"
        >
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">扶贫直销店</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor1" :key="index" v-html="item">
              {{ item }}
            </p>
            <p>
              7、法人店铺授权委托书&nbsp;<span
                style="font-size: 13px; color: #9b9b9b"
                >请下载</span
              ><a
                target="_blank"
                :href="downFileUrl1"
                download="授权委托书模板.doc"
                style="color: #0089ef; font-size: 13px"
                >授权委托书模板</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="goToShop">
      <div class="goToShopDetails">
        <el-checkbox v-model="checked" />我已阅读并接受<span
          class="shopagreementcss"
          @click="shopagreementHand"
          >《商家入驻协议》</span
        >
      </div>
    </div>
    <div
      v-if="checked"
      class="data-bottom-btn"
      style="
        margin-bottom: 20px;
        font-family: PingFangSC-Semibold, PingFangSC;
        font-weight: 600;
      "
      @click="nextStepClick"
    >
      下一步
    </div>
    <div
      v-else
      class="data-bottom-btn1"
      style="
        margin-bottom: 20px;
        font-family: PingFangSC-Semibold, PingFangSC;
        font-weight: 600;
      "
    >
      下一步
    </div>
    <el-dialog
      title="商家入驻协议"
      :visible.sync="shopagreement"
      width="700px"
      show-divider
      show-shadow
      :before-close="handleClose"
      class="dialog-center"
      custom-class="el-dialog--customize"
    >
      <div class="agreementModalCss" v-html="shopagreements.shopagreements" />
      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="shopagreement = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ScrollPane from "@/views/layout/components/TagsView/ScrollPane";
import shopagreements from "./shop-agreement";
export default {
  name: "readyDataIndex",
  components: { ScrollPane },
  data() {
    return {
      downFileUrl1: this.$addUrlPerFix(process.env.VUE_APP_FILE_URL_FILE),
      shopagreement: false,
      shopagreements: shopagreements,
      infor1: [
        "1、企业营业执照副本复印件（三证合一，需完成有效年检且所售商品属于经营范围内）",
        "2、一般纳税人证",
        "3、银行开户许可证复印件",
        "4、法定代表人身份证正反面复印件",
        "5、店铺负责人身份证正反面复印件",
        "6、由国家商标总局颁发的商标注册证或商标注册申请受理通知书复印件（若办理过变更、转让、 续展，请一并提供商标总局颁发的变更、转让、续展证明或受理通知书）",
      ],
      infor2: [
        "1、企业营业执照副本复印件（三证合一，需完成有效年检且所售商品属于经营范围内）",
        "2、一般纳税人证",
        "3、由国家商标总局颁发的商标注册证或商标注册申请受理通知书复印件（若办理过变更、转让、 续展，请一并提供商标总局颁发的变更、转让、续展证明或受理通知书）",
        "4、银行开户许可证复印件",
        "5、法定代表人身份证正反面复印件",
        "6、店铺负责人身份证正反面复印件",
        "7、商标权人出具的授权书（若商标权人为自然人， 则需同时提供其亲笔签名的身份证复印件）",
      ],
      infor3: [
        "1、企业营业执照副本复印件（三证合一，需完成有效年检且所售商品属于经营范围内）",
        " 2、一般纳税人证",
        "3、银行开户许可证复印件",
        "4、法定代表人身份证正反面复印件",
        "5、店铺负责人身份证正反面复印件",
        "6、自有品牌：由国家商标总局颁发的商标注册证或商标注册申请受理通知书复印件（若办理过变更、转让、续展，请一并提供商标总局颁发的变更、转让、续展证明或受理通知书）",
        "7、代理品牌：<br />（1）由国家商标总局颁发的商标注册证或商标注册申请受理通知书复印件（若办理过变更、转让、续展，请一并提供商标总局颁发的变更、转让、续展证明或受理通知书）<br />（2）上一级的正规品牌授权文件或正规采购合同及进货发票，若上一级的授权方或供货商为自然人，则需同时提供其亲笔签名的身份证复印件",
      ],
      checked: false,
    };
  },
  mounted() {
    this.$store.commit("RELOAD_SET", false);
  },
  methods: {
    down() {
      console.log("fdsfds");
    },
    nextStepClick() {
      this.$store.commit("DEL_CACHED_VIEW", { name: "applyShopInfo" });
      this.$store.commit("DEL_CACHED_VIEW", { name: "inputBusinessInfo" });
      this.$store.dispatch("businessOpenShopSetStep", 2);
      this.$router.replace("/business-open-shop/register");
    },
    shopagreementHand() {
      this.shopagreement = true;
    },
    handleClose(done) {
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.ready-data {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  min-height: calc(100vh - 285px) !important;
  height: auto !important;

  .goToShop {
    width: 1180px;
    height: 18px;
    margin-bottom: 20px;
    font-family: PingFang-SC-Medium;
    font-size: 13px;
    color: #9b9b9b;
    line-height: 18px;
    .goToShopDetails {
      width: 290px;
      height: 100%;
      margin: 0 auto;
      text-align: center;
    }
    .shopagreementcss {
      color: #f50b25;
      cursor: pointer;
    }
  }
}
.ready-data-content {
  width: 100%;
  min-height: 245px;
  .phy {
    // float: left;
    margin-top: 30px;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.23);
    float: left;
    .information {
      //width: 460px;
      height: 357px;
      margin-top: 20px;
      margin-left: 20px;
      overflow-y: auto;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #4a4a4a;
      padding: 0 20px;
      p {
        margin: 16px 0px;
      }
    }
    .titleStyle {
      width: 160px;
      height: 40px;
      background: #ff262b;
      border-radius: 0 18.5px 18.5px 0;
      border-radius: 0px 18.5px 18.5px 0px;
      margin-left: -9px;
    }
    .titleFonts {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
    .topTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      margin-top: 11px;
      border-bottom: 9px solid brown;
      border-left: 9px solid transparent;
    }
    .buttomTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      border-top: 9px solid brown;
      border-left: 9px solid transparent;
    }
  }
  .phy1 {
    //margin-top: 30px;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.23);
    float: left;
    .information {
      //width: 460px;
      height: 357px;
      margin-top: 20px;
      margin-left: 20px;
      overflow-y: auto;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #4a4a4a;
      padding: 0 20px;
      p {
        margin: 16px 0px;
      }
    }
    .titleStyle {
      width: 160px;
      height: 40px;
      background: #ff262b;
      border-radius: 0 18.5px 18.5px 0;
      border-radius: 0px 18.5px 18.5px 0px;
      margin-left: -9px;
    }
    .titleFonts {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
    .topTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      margin-top: 11px;
      border-bottom: 9px solid brown;
      border-left: 9px solid transparent;
    }
    .buttomTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      border-top: 9px solid brown;
      border-left: 9px solid transparent;
    }
  }
  > span {
    font-size: 36px;
    font-weight: 400;
    color: #999999;
  }
}
.business-open-content {
  margin-top: 20px;
}

.agreementModalCss {
  color: #666666;
  font-size: 13px;
  padding: 0 50px;
  height: 530px;
  overflow-y: auto;
  /deep/ .title {
    display: block;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: 600;
  }
  /deep/ > div:nth-of-type(1) {
    margin-bottom: 20px;
  }
  /deep/ > div:nth-of-type(2) {
    div {
      margin-top: 10px;
      margin-bottom: 5px;
    }
    span {
      display: block;
    }
  }
}
/deep/ .title {
  display: block;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: #212121;
}
/deep/ .remind {
  isplay: block;
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: red;
}
/deep/ .titleInfor {
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: #212121;
}
/deep/ .el-checkbox {
  margin-right: 5px;
}
/deep/ .infrobottom {
  margin-bottom: 20px;
}
/deep/ .el-dialog--customize .el-dialog__body {
  max-height: 130vh !important;
}
</style>
